import { defineMessages } from "@mnemonic/intl";

export const commonMessages = defineMessages({
  AD3: { id: "AD3", defaultMessage: "AD3" },
  AuthenticationFailed: { id: "AuthenticationFailed", defaultMessage: "Authentication failed" },
  Authorize: { id: "Authorize", defaultMessage: "Authorize" },
  Cancel: { id: "Cancel", defaultMessage: "Cancel" },
  ChangePassword: { id: "ChangePassword", defaultMessage: "Change password" },
  ContactUs: { id: "ContactUs", defaultMessage: "Contact us" },
  Customers: { id: "Customers", defaultMessage: "Customers" },
  EnrollmentCode: { id: "EnrollmentCode", defaultMessage: "Enrollment code" },
  GenericErrorTitle: { id: "GenericErrorTitle", defaultMessage: "Something went wrong" },
  LogOut: { id: "LogOut", defaultMessage: "Log out" },
  OPENID: { id: "Openid", defaultMessage: "Single sign on" },
  PASSWORD: { id: "Password", defaultMessage: "Password" },
  SIGNATURE: { id: "Signature", defaultMessage: "Security Key" },
  SMS: { id: "SMS", defaultMessage: "SMS" },
  SetPassword: { id: "SetPassword", defaultMessage: "Set password" },
  TOTP: { id: "TOTP", defaultMessage: "Time-based One Time Password (TOTP)" },
  TokenCode: { id: "TokenCode", defaultMessage: "Token code" },
  UnknownError: { id: "UnknownError", defaultMessage: "Unknown error" },
  VerificationCode: { id: "VerificationCode", defaultMessage: "Verification code" },
  SMSVerificationCode: { id: "SMSVerificationCode", defaultMessage: "SMS Verification code" },
  UnsupportedAuthorizationMethod_title: {
    id: "UnsupportedAuthorizationMethod.title",
    defaultMessage: "Authentication method not supported",
  },
  UnsupportedAuthorizationMethod_enrollment: {
    id: "UnsupportedAuthorizationMethod.enrollment",
    defaultMessage: "This action can't be authorized right after enrollment.",
  },
  UnsupportedAuthorizationMethod_generic: {
    id: "UnsupportedAuthorizationMethod.generic",
    defaultMessage: "The method you are logged in with (<b>{method}</b>) cannot authorize this action.",
  },
  UnsupportedAuthorizationMethod_tryAgain: {
    id: "UnsupportedAuthorizationMethod.tryagain",
    defaultMessage: "Please log out, log back in and try again.",
  },
  UnsupportedAuthorizationMethod_tryAgain_generic: {
    id: "UnsupportedAuthorizationMethod.tryagain.generic",
    defaultMessage: "Please log in using a different method, then try again.",
  },
});
